import { If, Media } from "components";
import { MediaType } from "constants/enums";
import { t } from "i18next";
import { useState } from "react";
import { LightBoxGallery } from "ui";

import { ReturnModalAtomProps } from "../../ReturnModal.types";
import { ReturnModalBlock } from "./ReturnModalBlock";

import styles from "../../ReturnModal.module.scss";

export const ReturnModalReasonBlock = ({
  returnDetails
}: ReturnModalAtomProps) => {
  const [openedImageIndex, setOpenedImageIndex] = useState<number>();

  return (
    <ReturnModalBlock label={t("Reason")}>
      <div className={styles.returnModal_reason}>
        {returnDetails.returnReason}

        <If condition={returnDetails.returnDescription}>
          <div className={styles.returnModal_reason_description}>
            {returnDetails.returnDescription}
          </div>
        </If>

        <If condition={returnDetails.returnImages.length}>
          <div className={styles.returnModal_reason_images}>
            {returnDetails.returnImages.map((image, index) => (
              <div
                key={image.id}
                className={styles.returnModal_reason_imageWrapper}
              >
                <Media
                  className={styles.returnModal_reason_image}
                  mediaFile={image}
                  autoPlay={false}
                  withVideoLabel={true}
                  onClick={(e) => {
                    if (image.mediaType !== MediaType.DOCUMENT) {
                      e.preventDefault();
                      setOpenedImageIndex(index);
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </If>
      </div>

      <LightBoxGallery
        mediaList={returnDetails.returnImages}
        openedImageIndex={openedImageIndex}
        setOpenedImageIndex={setOpenedImageIndex}
      />
    </ReturnModalBlock>
  );
};
